// eslint-disable-next-line no-restricted-imports
import { Toast as IToast, ToastSeverityEnum as IToastSeverityEnum } from '@eih-netbroker/api-user-stream';

export type Toast = IToast;
export const ToastSeverityEnum = IToastSeverityEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ToastSeverityEnum = (typeof IToastSeverityEnum)[keyof typeof IToastSeverityEnum];
